import { useState, useEffect } from 'react';
import './Produtos.css';
import { PRODUTOS } from '../../data/produtos';

function ProdutoFoto({ imagens, alt }) {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (imagens.length < 2) return;
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % imagens.length);
        setFading(false);
      }, 600);
    }, 3500);
    return () => clearInterval(interval);
  }, [imagens.length]);

  return (
    <>
      <img
        src={imagens[current]}
        alt={alt}
        className={`produto__foto ${fading ? 'produto__foto--fading' : ''}`}
      />
      {imagens.length > 1 && (
        <div className="produto__dots">
          {imagens.map((_, i) => (
            <span key={i} className={`produto__dot ${i === current ? 'produto__dot--active' : ''}`} />
          ))}
        </div>
      )}
    </>
  );
}

const WHATSAPP_NUMERO = '5511917957625';

function linkWhatsApp(produto) {
  const mensagem = `Olá! Tenho interesse em comprar: ${produto.nome} (${produto.preco})`;
  return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(mensagem)}`;
}

export default function Produtos() {
  return (
    <section id="produtos" className="produtos">
      <div className="produtos__inner">
        <div className="produtos__header">
          <div>
            <span className="section-tag">Produtos</span>
            <h2 className="section-title">Vista-se com propósito</h2>
          </div>
          <p className="section-subtitle">
            Cada peça é única e cheia de significado. Escolha a sua e transforme vidas junto com a gente.
          </p>
        </div>

        <div className="produtos__grid">
          {PRODUTOS.map((p) => (
            <div key={p.id} className="produto">
              <div className="produto__img">
                <ProdutoFoto imagens={p.imagens} alt={p.nome} />
                <span className="produto__badge">{p.badge}</span>
              </div>
              <div className="produto__info">
                <p className="produto__desc">{p.desc}</p>
                <div className="produto__footer">
                  <span className="produto__preco">{p.preco}</span>
                  <a
                    href={linkWhatsApp(p)}
                    className="produto__btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Comprar
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
